import { render, staticRenderFns } from "./course-batch-add.vue?vue&type=template&id=0db58ea0&"
import script from "./course-batch-add.vue?vue&type=script&lang=js&"
export * from "./course-batch-add.vue?vue&type=script&lang=js&"
import style0 from "./course-batch-add.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports